import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCustomerMoodThumbDownGreyActive = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M15.0218 8.66667V2.66667C15.0218 2.29848 14.7233 2 14.3551 2H12.6884V9.33333H14.3554C14.7236 9.33333 15.0218 9.03486 15.0218 8.66667Z",
		fill: "#6B6B6B"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.0218 9.37783V2H5.77698C4.92568 2 4.16767 2.5389 3.888 3.34296L2.61264 7.00962C2.16057 8.30931 3.12557 9.66667 4.50162 9.66667H7.02178C7.02178 9.66667 6.68844 10.8667 6.68844 11.6667C6.68844 12.6667 7.10072 13.6667 8.35511 13.6667C10.0218 13.6667 10.0218 12.3333 10.0218 11.6667C10.0218 10.7746 11.0828 9.61726 12.0218 9.37783Z",
		fill: "#6B6B6B"
	})]
});
export default SvgCustomerMoodThumbDownGreyActive;
